<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_1"></a><em>Money over Mastery, Family over Freedom</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Halftitle1.vue?b8d28b78